﻿<template>
    <div :class="{ 'full-page-height': props.fullHeight }">
        <navigation :label="props.label" :extra-breadcrumb="props.extraBreadcrumb" :to="props.to" />

        <div class="q-pa-lg row items-start q-gutter-md items-stretch justify-center-smart" :class="{ 'col': props.fullHeight }">
            <q-card flat class="column width-dialog-standard" :class="props.pageClass">
                <slot v-if="props.useCustomContent" />
                <qe-form ref="primaryForm" autofocus v-else>
                    <q-card-section>
                        <div class="text-h5 q-mb-sm" v-if="props.useCaption">
                            {{ props.caption.length > 0 ? props.caption : props.label }}
                        </div>

                        <slot />
                    </q-card-section>

                    <q-card-actions align="right" v-if="props.useButtons">
                        <q-btn
                            v-if="useSecondButton"
                            outline color="primary" :label="props.cancelBtn"
                            @click="emits( 'cancel' )" />
                        <q-btn
                            outline color="primary" :label="props.okBtn"
                            @click="okBtnClick()" />
                        <q-btn
                            outline color="primary" :label="props.thirdBtn"
                            @click="thirdBtnClick()" v-if="props.useThirdButton"/>
                    </q-card-actions>
                </qe-form>
            </q-card>
        </div>
    </div>
</template>

<script setup lang="ts">
import Navigation from "@/components/parts/navigation.vue"
import QeForm from "@/components/qe/qeForm.vue"
import { ts } from "@/plugins/i18nFormat"
import { ref } from "vue"

import type { RouteLocationRaw } from "vue-router"

interface Props {
    label: string
    caption?: string
    cancelBtn?: string
    okBtn?: string
    thirdBtn?: string
    useCaption?: boolean
    useButtons?: boolean
    useSecondButton?: boolean
    useThirdButton?: boolean
    useCustomContent?: boolean
    pageClass?: string
    extraBreadcrumb?: string
    to?: RouteLocationRaw
    fullHeight?: boolean
}

const props = withDefaults( defineProps<Props>(), {
    label: '',
    caption: '',
    cancelBtn: ts( 'cancel' ),
    okBtn: ts( 'save' ),
    thirdBtn: '',
    useForm: true,
    useButtons: true,
    useSecondButton: true,
    useThirdButton: false,
    useCustomContent: false,
    pageClass: '',
    extraBreadcrumb: '',
    to: null,
    fullHeight: false
} )

const emits = defineEmits( [ 'cancel', 'ok', 'third' ] )

const primaryForm = ref()

async function okBtnClick () {
    if ( await primaryForm.value?.validate() )
        emits( 'ok' )
}

async function thirdBtnClick () {
    if ( await primaryForm.value?.validate() )
        emits( 'third' )
}
</script>

<style lang="sass" scoped>
.width-dialog-standard
  min-width: 512px
  width: 66vw
  max-width: 1280px

.justify-center-smart
  justify-content: left

  @media screen and (min-width: 1150px)
    justify-content: center

.full-page-height
  display: flex
  flex-direction: column
  min-height: calc(100vh - 50px) // Adjust based on layout (navbar etc)
</style>
